  <template>
  <div class="module-content">
    <div class="module-header" v-if="supporter">
      <div class="left">
        <router-link class="back" :to="redirectTo" title="Back to list" select-cy="back">
          <i class="icn icn-chevron-left"></i>
        </router-link>
        <h2>{{ supporter.firstName || supporter.name }} {{ supporter.lastName }}</h2>
      </div>
    </div>

    <div class="content w-full container module-item">
      <SupporterDetails v-bind:supporter="supporter"></SupporterDetails>
      <SupporterDonations v-bind:supporter="supporter"></SupporterDonations>
    </div>
  </div>
</template>

<script>
import SupporterDetails from './Details/SupporterDetails.vue';
import SupporterDonations from './Donations/SupporterDonations.vue';
import { MESSAGES } from '@/helpers/constants';

export default {
  name: 'SupporterView',
  components: {
    SupporterDetails,
    SupporterDonations,
  },

  data() {
    return {
      supporter: undefined,
    };
  },
  computed: {
    refresh() {
      return this.$store.getters['supporters/refresh'];
    },
    redirectTo() {
      return this.$route.params.q ? `/supporters/search?q=${this.$route.params.q}` : '/supporters';
    },
  },
  watch: {
    '$route.params.id': function (id) {
      this.getSupporterDetail(id);
    },
    refresh() {
      this.getSupporterDetail(this.$route.params.id);
    },
  },

  mounted: function () {
    this.getSupporterDetail(this.$route.params.id);
  },

  methods: {
    getSupporterDetail(supporterId) {
      this.$store
        .dispatch('supporters/get', { ids: supporterId, limit: 1 })
        .then((result) => {
          this.supporter = result.data[0];
        })
        .catch((err) => {
          console.error(err);
          let msg = 'Please try again later or contact an administrator.';
          if (err && err.status && err.status === 401) {
            msg = 'You cannot get this supporter. Please try again later or contact an administrator.';
          }
          this.$store.dispatch('notifications/error', {
            headline: MESSAGES.ERROR_FETCH,
            details: msg,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
}
.page-header {
  position: relative;
  height: 65px;
  top: 0;
  left: 0;
  right: 0;
  background: #f9fafb;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.06);
  padding: 0px 0px 0px 24px;
  display: flex;
  align-items: center;
}
.supporter-page-content {
  display: flex;
  align-items: flex-start;
}

.supporter-detail {
  margin: 20px;
}

.supporter-donations {
  margin: 20px 20px 20px 0;
}
</style>
